import HTTP from "@/_helpers/http";
import {
    WITHDRAWMETHODS__API
} from "@/_helpers/urls";
import {
    WITHDRAWMETHODS__MUTATIONS
} from "../mutation-types";
import {
    WITHDRAWMETHODS__ACTIONS
} from "../action-types";
import toast from "@/services/Notification";
import router from "@/router";

// State
const state = {
    methods: [],
    accounts: [],
    banks: [],
    inrrate: [],
    addresses: [],
    otp_via: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [WITHDRAWMETHODS__MUTATIONS.WITHDRAWMETHODS](state, data) {
        state.methods = data;
    },
    [WITHDRAWMETHODS__MUTATIONS.BROKERSBANK](state, data) {
        state.banks = data;
    },
    [WITHDRAWMETHODS__MUTATIONS.WITHDRAWACCOUNTS](state, data) {
        state.accounts = data;
    },
    [WITHDRAWMETHODS__MUTATIONS.USERCRYPTOADDRESS](state, data) {
        state.addresses = data;
    },
    [WITHDRAWMETHODS__MUTATIONS.INRRATE](state, data) {
        state.inrrate = data;
    },
    [WITHDRAWMETHODS__MUTATIONS.OTPVIA](state, data) {
        state.otp_via = data;
    },
};

// Actions
const actions = {
    async [WITHDRAWMETHODS__ACTIONS.OTPVIA]({
        commit,
        state
    }, flag) {
        try {
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(WITHDRAWMETHODS__API.OTPVIA);
            commit(WITHDRAWMETHODS__ACTIONS.OTPVIA, response?.data?.is_sms);
        } catch (error) {
            console.log(error);
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.CREATEBANKWITHDRAW]({
        commit,
        state
    }, data) {
        try {
            const url = `${WITHDRAWMETHODS__API.CREATEBANKWITHDRAW}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Withdrawal Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to Withdrawal")
        }
    },

    async [WITHDRAWMETHODS__MUTATIONS.INRRATE]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.INRRATE}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            // console.log(url);return;
            commit(WITHDRAWMETHODS__MUTATIONS.INRRATE, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.WITHDRAWOTP]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.WITHDRAWOTP}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url);
            if (response.status === 200) {
                toast.success(response.data.message || "Withdrawal otp sent Successfull")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to Withdrawal otp sent")
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.CREATECASHWITHDRAW]({
        commit,
        state
    }, data) {
        try {
            const url = `${WITHDRAWMETHODS__API.CREATECASHWITHDRAW}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Withdrawal Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to Withdrawal")
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.CREATECRYPTOWITHDRAW]({
        commit,
        state
    }, data) {
        try {
            const url = `${WITHDRAWMETHODS__API.CREATECRYPTOWITHDRAW}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Withdrawal Successfull")
                router.push("/wallet")
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Failed to Withdrawal")
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.USERCRYPTOADDRESS]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.USERCRYPTOADDRESS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(WITHDRAWMETHODS__MUTATIONS.USERCRYPTOADDRESS, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.WITHDRAWMETHODS]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.WITHDRAWMETHODS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(WITHDRAWMETHODS__MUTATIONS.WITHDRAWMETHODS, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.WITHDRAWACCOUNTS]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.WITHDRAWACCOUNTS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(WITHDRAWMETHODS__MUTATIONS.WITHDRAWACCOUNTS, response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [WITHDRAWMETHODS__ACTIONS.BROKERSBANK]({
        commit,
        state
    }) {
        try {
            const url = `${WITHDRAWMETHODS__API.BROKERSBANK}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(WITHDRAWMETHODS__MUTATIONS.BROKERSBANK, response.data);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};